import { Block, Image } from "../../../../src/components/project/project";
import * as React from 'react';
export default {
  Block,
  Image,
  React
};